import { useEffect, useState } from "react";
import { BusinessGooglePlace } from "../interfaces/BusinessObject";
import { getGooglePlaceRating } from "../services/apiServices/GooglePlaceRatingApiService";

/** Only retained for this mounted view: no localStorage, Redux persistence, cache, or polling. */
export function useBusinessGooglePlace(businessId: string, placeId: string | undefined): BusinessGooglePlace | null {
  const key = JSON.stringify([businessId, placeId]);
  const [result, setResult] = useState<{ key: string; place: BusinessGooglePlace | null } | null>(null);

  useEffect(() => {
    setResult(null);
    if (!businessId || !placeId) return;
    const controller = new AbortController();
    let active = true;
    let timeout: ReturnType<typeof setTimeout> | undefined;
    // Deferral avoids duplicate paid calls from React StrictMode's setup/cleanup cycle.
    const start = setTimeout(() => {
      timeout = setTimeout(() => controller.abort(), 6500);
      getGooglePlaceRating(placeId, controller.signal)
        .then((place) => { if (active) setResult({ key, place }); })
        .catch(() => { if (active) setResult({ key, place: null }); })
        .finally(() => clearTimeout(timeout));
    }, 0);

    return () => {
      active = false;
      clearTimeout(start);
      clearTimeout(timeout);
      controller.abort();
    };
  }, [businessId, placeId, key]);

  return result?.key === key ? result.place : null;
}

